import { config } from "#internal/config";

export const authWithPassport = () => {
  const searchParams = new URLSearchParams({
    retpath: window.location.href,
    origin: "fleet-forms",
  });

  window.location.replace(`${config.passportURL}/auth?${searchParams}`);
};
